if (!Array.prototype.at) {
  Array.prototype.at = function (index) {
    if (this == null) {
      throw new TypeError('this is null or not defined');
    }
    const arr = Object(this);
    const len = arr.length >>> 0;
    const relativeIndex = Math.trunc(Number(index)) || 0;
    const absoluteIndex = relativeIndex < 0 ? len + relativeIndex : relativeIndex;
    if (absoluteIndex < 0 || absoluteIndex >= len) {
      return undefined;
    }
    return arr[absoluteIndex];
  };
}
